import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ExperiencesService } from '../../services/experiences.service';
import { Experience, ExperienceShort } from '../../services/interfaces/experiences';
import { TransparencyService } from '../../utils/transparency.service';
import { NgForm } from '@angular/forms';
import { CurrencyPipe } from '@angular/common';
import { DWSTag, TagExpType, TagLang, TagService } from '../../services/interfaces/tags';
import { TagsService } from '../../utils/tags.service';
import { AvailabilitiesService } from '../../services/availabilities.service';
import { AvailabilitiesResponse, DayData,AvailabilityTimePeople } from '../../services/interfaces/availabilities';
import { CalendarMonthChangeEvent } from 'primeng/calendar';
import { PeopleDropdownComponent } from '../../pages/experience/people-dropdown/people-dropdown.component';
import { ExtraDropdownComponent } from '../../extra-dropdown/extra-dropdown.component';
import { FormDataService } from '../../services/form-data.service';
import { MessageService } from 'primeng/api';
import { CompaniesService } from 'app/services/companies.service';
import { Company } from 'app/services/interfaces/company';
import { getImageUrl } from '../../utils/image.utils';
import { ExperiencesStateService } from '../../services/experiences-state.service';
import { ExperienceStateService } from '../../services/experience-state.service';
import { kebabCase } from 'lodash';
import { Carousel } from 'primeng/carousel';



@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrls: ['./experience.component.scss'],
})
export class ExperienceComponent implements OnInit {

  // Variabili dichiarate nel tuo componente
  selectedLanguage: any;
  selectedTime: any;
  isValid: boolean = false;
  isReservation: boolean = true; 
  isLanguageSelected: boolean = false;
  isLanguageAndDateSelected: boolean = false;
  isLanguageDateAndTimeSelected: boolean = false;
  isExtraDisabled: boolean = false;
  isDateSelected: boolean = false;
  selectedTab: string = 'Prenota';
  isPeopleSelectable: boolean = false;
  peopleTotalPrice: number = 0;
  extraTotalPrice: number = 0;
  combinedTotalPrice: number = 0;
  numberOfPeople: number = 0;
  labelCounts: number[] = [];
  selectedDate: Date | null = null; // Date object for calendar display
  formData: {
    language: string;
    date: string;
    time: string;
    people: number[];
    extras: string;
    experience_price_labels: {
      count: number;
      id: number;
      title_translations: { [key: string]: string };
      price_cents: number;
      price_currency: string;
      position: number;
      experience_id: string;
      created_at: string;
      updated_at: string;
      quantity: number;
    }[];
  } = {
      language: '',
      date: '',
      time: '',
      people: [],
      extras: '',
      experience_price_labels: []
    };

 

  // IN ATTESA DI SERVICES
  experienceService = [
    { icon: 'assets/icons/Servizi_icone/Accesso_disabili.svg', name: 'Accesso disabili' },
    { icon: 'assets/icons/Servizi_icone/Accetta_carte_di_credito.svg', name: 'Accetta carte di credito' },
    { icon: 'assets/icons/Servizi_icone/Agriturismo.svg', name: 'Agriturismo' },
    { icon: 'assets/icons/Servizi_icone/Animali_ammessi.svg', name: 'Animali ammessi' },
    { icon: 'assets/icons/Servizi_icone/Animali_non_ammessi.svg', name: 'Animali non ammessi' },
    { icon: 'assets/icons/Servizi_icone/Area_panoramica_esterna_per_eventi.svg', name: 'Area panoramica esterna per eventi' },
    { icon: 'assets/icons/Servizi_icone/Attivita_sportive.svg', name: 'Attività sportive' },
    { icon: 'assets/icons/Servizi_icone/Autista.svg', name: 'Autista' },
    { icon: 'assets/icons/Servizi_icone/Barbecue_elettrico.svg', name: 'Barbecue elettrico' },
    { icon: 'assets/icons/Servizi_icone/Bed_&_Breakfast.svg', name: 'Bed & Breakfast' },
    { icon: 'assets/icons/Servizi_icone/Bistrot.svg', name: 'Bistrot/Ristorante' },
    { icon: 'assets/icons/Servizi_icone/Camere_e_Appartamenti.svg', name: 'Camere e Appartamenti' },
    { icon: 'assets/icons/Servizi_icone/Con_pernottamento.svg', name: 'Con pernottamento' }
  ];


  experience: Experience | undefined;
  sortedMedias: any[] = []; // Array ordinato con mainCover come prima
  spklangTags: any[] = [];
  allTypeTags: any[] = [];
  experienceId: string | undefined;
  experiences: string | any[] | null | undefined;
  disabledDates: Date[] = [];
  availableDates: Date[] = [];
  availableTimes: {
    occupiedCount: any;
    minParties: any; label: string, value: string 
}[] = [];

  responsiveOptionsExperience = [
    { breakpoint: '1470px', numVisible: 4, numScroll: 4 },
    { breakpoint: '1000px', numVisible: 3, numScroll: 3 },
    { breakpoint: '800px', numVisible: 2, numScroll: 2 }
  ];
  @ViewChild('checkoutForm') checkoutForm: NgForm | undefined;
  @ViewChild('peopleDropdown') peopleDropdown!: PeopleDropdownComponent;
  @ViewChild('extraDropdown') extraDropdown!: ExtraDropdownComponent;
  @ViewChild('experienceCarousel') experienceCarousel!: Carousel;
  availabilities: DayData[] = [];
  minParties: number | undefined;
  maxParties: number | undefined;
  occupiedCount: number | undefined;
  companies: Company | undefined;
  dayStatuses: { [key: string]: string } = {}; // Store day statuses for coloring

  timePeopleInfo: AvailabilityTimePeople = { minParties: 0, maxParties: 0, occupiedCount: 0 };
  isAvailabilityErrorVisible: boolean = false;
  availabilityErrorMessage: string = '';
  get tagList(): string {
    return this.allTypeTags
        .filter(tag => tag)
        .map(tag => tag.name)
        .join(', ');
}
  constructor(
    private route: ActivatedRoute,
    private experienceServices: ExperiencesService,
    private transparencyService: TransparencyService,
    private router: Router,
    private location: Location,
    private elementRef: ElementRef,
    private cp: CurrencyPipe,
    private _tagService: TagsService,
    private availabilitiesService: AvailabilitiesService,
    private formDataService: FormDataService,
    private companiesService: CompaniesService,
    private messageService: MessageService,
    private experiencesStateService: ExperiencesStateService,
    private experienceStateService: ExperienceStateService
  ) { }

  
  async ngOnInit(): Promise<void> {
    this.transparencyService.setTransparency(false);
    this.getExperienceIdFromUrl();

    this.loadExperience(); 
  
    // Don't load availabilities until language is selected
    // this.loadCurrentMonthAvailabilities();
    this.elementRef.nativeElement.ownerDocument.documentElement.scrollTop = 0;
    this.updateIsPeopleSelectable();
    this.updateExtrasDisabledState();
  }
  handleNumberOfPeopleChange(numberOfPeople: number) {
    this.numberOfPeople = numberOfPeople;
  }

  handleLabelCountsChange(labelCounts: number[]) {
    this.labelCounts = labelCounts;

  }

  getCompany(companyId: string) {
    this.companiesService.getCompany(companyId).subscribe((company) => {
      this.companies = company;
    });
  }
 
  updateIsValid(isValid: boolean) {
    this.isValid = isValid;
  }
  onTabChange(event: any) {
    this.isReservation = event.index === 0;
    this.checkoutForm?.reset();
    this.isLanguageSelected = false;
    this.isLanguageAndDateSelected = false;
    this.isLanguageDateAndTimeSelected = false;
    this.selectedLanguage = null;
    this.selectedTime = null;
    this.hideAvailabilityError();
    this.updateIsPeopleSelectable();
    if (this.peopleDropdown) {
      this.peopleDropdown.reset();
    }
  }
  
  updateIsPeopleSelectable() {
    if (!this.isReservation) {
      this.isPeopleSelectable = true;
      this.isLanguageDateAndTimeSelected = true;
    } else {
      this.isLanguageDateAndTimeSelected = false;
    }
  }
  updatePeopleTotalPrice(newTotalPrice: number) {
    this.peopleTotalPrice = newTotalPrice;
    this.updateCombinedTotalPrice();
  }

  updateExtraTotalPrice(newTotalPrice: number) {
    this.extraTotalPrice = newTotalPrice;
    this.updateCombinedTotalPrice();
  }

  updateCombinedTotalPrice() {
    this.combinedTotalPrice = this.peopleTotalPrice + this.extraTotalPrice;
  }

  updateTotalPrice(source: 'people' | 'extra', newTotalPrice: number) {
    if (source === 'people') {
      this.updatePeopleTotalPrice(newTotalPrice);
    } else if (source === 'extra') {
      this.updateExtraTotalPrice(newTotalPrice);
    }
  }

  ciao($event: CalendarMonthChangeEvent) {
    var month = $event.month

  }

  private loadExperience(): void {
    if (this.experienceId) {
      this.experienceServices.getExperienceById(this.experienceId).subscribe({
        next: (experience: Experience) => {
          this.experience = experience;

          // Ordina le immagini: mainCover come prima, poi le altre
          if (this.experience.medias && Array.isArray(this.experience.medias)) {
            this.sortedMedias = [...this.experience.medias].sort((a, b) => {
              // Se a è mainCover, viene prima
              if (a.mediaType === 'mainCover' && b.mediaType !== 'mainCover') {
                return -1;
              }
              // Se b è mainCover, viene prima di a
              if (b.mediaType === 'mainCover' && a.mediaType !== 'mainCover') {
                return 1;
              }
              // Altrimenti mantieni l'ordine originale
              return 0;
            });
          } else {
            this.sortedMedias = [];
          }

          // Gestisce languagesIsoCode per le lingue
          if (this.experience.languagesIsoCode && Array.isArray(this.experience.languagesIsoCode)) {
            // Trova i tag lingua dal TagsService usando i codici ISO
            this.spklangTags = this.experience.languagesIsoCode.map((langCode: string) => {
              const langCodeLower = langCode.toLowerCase();
              return this._tagService.getAllLang('it').find(l => l.code === langCodeLower);
            }).filter(tag => tag !== undefined);
          } else {
            this.spklangTags = [];
          }

          // Gestisce metaDatas per gli altri tag (escludendo quelli che sono lingue)
          if (this.experience.metaDatas && Array.isArray(this.experience.metaDatas)) {
            // Filtra i metaDatas che non sono lingue (quelli che iniziano con "lang_")
            const metaTags = this.experience.metaDatas
              .filter((meta: any) => !meta.metadataValue?.startsWith('lang_'))
              .map((meta: any) => {
                // Cerca il tag nel TagsService usando il metadataValue come codice
                // Prova prima nei types, poi nei services
                const typeTag = this._tagService.getAllTypes('it').find((t: any) => t.code === meta.metadataValue);
                if (typeTag) return typeTag;
                const serviceTag = this._tagService.getAllServices('it').find((s: any) => s.code === meta.metadataValue);
                return serviceTag;
              })
              .filter((tag: any) => tag !== undefined);
            this.allTypeTags = metaTags;
          } else {
            this.allTypeTags = [];
          }

        // Use winery info from experience response if available, otherwise fetch from backend
        if (this.experience.winery && this.experience.winery.name) {
          // Winery info is already in the experience response - use it directly
          const place = this.experience.details?.place;
          this.companies = {
            id: this.experience.wineryId,
            name: this.experience.winery.name,
            description: '',
            opening_hours: '',
            nearby_cities: '',
            meta_title: '',
            meta_description: '',
            paypal_client_id: '',
            show_widget_filters: false,
            nexi_merchant: '',
            nexi_chiavemac: '',
            created_at: '',
            updated_at: '',
            max_experience_title_length: 100,
            place: {
              lat: place?.lat?.toString() || '0',
              lng: place?.lng?.toString() || '0',
              street: place?.street || '',
              city: this.experience.winery.city || place?.city || '',
              zipcode: place?.zipcode || '',
              province: place?.province || '',
              state: place?.state || '',
              region: place?.region || ''
            }
          };
        } else if (this.experience.wineryId) {
          // Fallback: fetch from backend if not in response
          this.getCompany(this.experience.wineryId);
        } else {
          console.warn('Company ID non disponibile per questa esperienza.');
        }
        
        // Restore state after experience is loaded
        this.restoreExperienceState();
        },
        error: (error: any) => {
          console.warn('Errore nel caricamento dell\'esperienza:', error);
          this.messageService.add({severity: 'error', summary: 'Error', detail: 'Errore nel caricamento dell\'esperienza, ricarica la pagina'});
        },
        complete: () => {
        }
      });
    }
  }

  onMonthChange(event: any) {

    const year = event.year;
    const month = event.month;
    const enableLangIso = this.selectedLanguage ? this.selectedLanguage.code : null;

    this.loadAvailabilities(year, month, enableLangIso);
    // Calcola e stampa tutte le date del mese selezionato
    const dates = this.getAllDatesInMonth(year, month);

  }

  onCalendarClick() {
    const enableLangIso = this.selectedLanguage ? this.selectedLanguage.code : null;
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;
    // Richiama loadAvailabilities passando l'anno e il mese correnti e il codice lingua selezionata
    this.loadAvailabilities(year, month, enableLangIso);
  }
  private loadCurrentMonthAvailabilities() {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    this.loadAvailabilities(year, month, this.formData.language);
  }




  private loadAvailabilities(year: number, month: number, enableLangIso: string | null) {


    if (!this.experienceId || !enableLangIso) {
      console.warn('Experience ID or enableLangIso is not defined.');
      return;
    }

    const startDate = `${year}-${month.toString().padStart(2, '0')}-01`;
    const endDate = new Date(year, month, 0);
    const endDateString = `${year}-${month.toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;

    this.availabilitiesService.getAvailabilities(this.experienceId, startDate, endDateString, enableLangIso)
      .subscribe((availabilities) => {
        this.availabilities = availabilities;
        this.updateAvailableAndDisabledDates(year, month);
        this.calculateDayStatuses();
      });
  }
  private updateAvailableAndDisabledDates(year: number, month: number) {
    if (!this.availabilities || this.availabilities.length === 0) {
      console.warn('Availabilities non disponibili o vuoti.');

    }

    const availableDatesStrings = this.availabilities
      .filter(dayData => dayData.availabilities && dayData.availabilities.length > 0)
      .map(dayData => dayData.day);

    this.disabledDates = this.getDisabledDates(year, month, availableDatesStrings);

  }

  private getDisabledDates(year: number, month: number, availableDates: string[]): Date[] {
    const allDates = this.getAllDatesInMonth(year, month);
    // Converte le stringhe ISO delle date disponibili in oggetti Date
    const availableDatesSet = new Set(availableDates.map(dateStr => new Date(dateStr)));

    // Filtra le date disponibili
    const disabledDates = allDates.filter(date => !this.dateSetHasDate(availableDatesSet, date));
    return disabledDates;

    
  }

  // Funzione ausiliaria per verificare se una data è presente nel Set di Date
  private dateSetHasDate(dateSet: Set<Date>, date: Date): boolean {
    for (const dateInSet of dateSet) {
      if (this.areDatesEqual(dateInSet, date)) {
        return true;
      }
    }
    return false;
  }

  // Funzione ausiliaria per verificare l'uguaglianza tra due date
  private areDatesEqual(date1: Date, date2: Date): boolean {
    return date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate();
  }





  private getAllDatesInMonth(year: number, month: number): Date[] {
    const date = new Date(year, month - 1, 1);
    const dates = [];
    while (date.getMonth() === month - 1) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  }




  onGetAvailabilitiesClick(event: any) {

    this.selectedLanguage = event.value;
    // Also set formData.language for form submission
    if (this.selectedLanguage && this.selectedLanguage.code) {
      this.formData.language = this.selectedLanguage.code;
    }
    const experienceId = this.experienceId!;

    // Ottieni la data corrente
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // JavaScript mesi vanno da 0 a 11

    // Calcola le date di inizio e fine del mese corrente
    const startDate = `${year}-${month.toString().padStart(2, '0')}-01`;
    const endDate = new Date(year, month, 0); // Ultimo giorno del mese
    const endDateString = `${year}-${month.toString().padStart(2, '0')}-${endDate.getDate().toString().padStart(2, '0')}`;

    // Ottieni il codice della lingua selezionata
    const enableLangIso = this.selectedLanguage ? this.selectedLanguage.code : null;

    if (!enableLangIso) {
      console.warn('Language not selected');
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a language first.' });
      return;
    }

    // Hide any previous errors when loading new availabilities
    this.hideAvailabilityError();
    
    this.availabilitiesService.getAvailabilities(experienceId, startDate, endDateString, enableLangIso)
      .subscribe((response) => {

        this.availabilities = response || [];

        if (!this.availabilities || this.availabilities.length === 0) {
          console.warn('No availabilities data received from API.');
          this.showAvailabilityError('Nessuna disponibilità trovata per la lingua e il periodo selezionati.');
        }

        // Estrai e stampa i giorni disponibili
        const availableDays = this.availabilities.map(dayData => dayData.day);

        this.updateAvailableAndDisabledDates(year, month);
        this.calculateDayStatuses();
        this.isLanguageSelected = true;
       

      }, (error) => {
        console.error('Error fetching availabilities:', error);
        this.showAvailabilityError('Errore nel caricamento delle disponibilità. Riprova più tardi.');
      });
  }


  getAvailabilitiesForDay(day: string) {
    return this.availabilities.find(availabilities => availabilities.day === day);
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  onDateSelect(event: any) {
    if (!event) {
      console.error('Nessun evento fornito');
      return;
    }

    const selectedDate = event.value || event;

    if (!(selectedDate instanceof Date)) {
      console.error('La data selezionata non è un\'istanza di data');
      return;
    }

    // Hide any previous errors when selecting a new date
    this.hideAvailabilityError();

    // Store Date object for calendar display
    this.selectedDate = selectedDate;
    
    const selectedDateString = this.formatDate(selectedDate);
    // Set formData.date for form submission
    this.formData.date = selectedDateString;

    const availabilitiesForDay = this.getAvailabilitiesForDay(selectedDateString);

    if (availabilitiesForDay && availabilitiesForDay.availabilities) {
      this.availableTimes = availabilitiesForDay.availabilities.map(a => ({ label: a.time, value: a.time,minParties: a.min_parties,
        maxParties: a.max_parties,
        occupiedCount: a.occupied_count }));
      this.isLanguageAndDateSelected = true;
      this.isDateSelected = true;
      // Reset selected time when date changes
      this.selectedTime = null;
      this.formData.time = '';
     
    } else {
      this.availableTimes = [];
      this.selectedTime = null;
      this.formData.time = '';
    }
  }

  onTimeSelect(event: any) {
    this.isLanguageDateAndTimeSelected = true;
    this.updateExtrasDisabledState();
    const selectedTime = event.value;
    this.selectedTime = selectedTime;
    if (!selectedTime) {
      console.error('Nessuna ora selezionata');
      this.formData.time = '';
      this.isLanguageDateAndTimeSelected = false;
      return;
    }
    // Set formData.time for form submission
    if (typeof selectedTime === 'string') {
      this.formData.time = selectedTime;
    } else if (selectedTime.value) {
      this.formData.time = selectedTime.value;
    } else if (selectedTime.time) {
      this.formData.time = selectedTime.time;
    } else if (selectedTime.label) {
      this.formData.time = selectedTime.label;
    }
    // Estrai i valori aggiuntivi
    this.timePeopleInfo = {
      minParties: selectedTime.minParties || 0,
      maxParties: selectedTime.maxParties || 0,
      occupiedCount: selectedTime.occupiedCount || 0
    };
  }
  updateExtrasDisabledState(): void {
    // Abilita gli extra solo se:
    // 1. Ci sono extra disponibili nella nuova struttura (experience.prices con priceType === "EXTRA")
    // 2. E se necessario, quando language/date/time sono selezionati (gestito da isLanguageDateAndTimeSelected)
    const hasExtras = this.getExtraPrices().length > 0;
    this.isExtraDisabled = !hasExtras || !this.isLanguageDateAndTimeSelected;
  }


  getAvailabilitiesForDayAndTime(day: string, time: string) {
    var filteredAva = this.availabilities.filter(availabilities => availabilities.day === day);
    if (filteredAva.length > 0) {
      return filteredAva[0];
    }
    return undefined;
  }
  getAvailabilitiesForCalendar(month: string) {

  }

  private getExperienceIdFromUrl(): void {
    // Prova prima il formato semplice (route temporanea per test)
    const simpleId = this.route.snapshot.paramMap.get('id');
    if (simpleId) {
      this.experienceId = simpleId;
      return;
    }
    
    // Altrimenti usa il formato normale con nome__id
    const param = this.route.snapshot.paramMap.get('experience_name__experience_id');
    this.experienceId = param?.split("__")[1] || '';
  }


  getLanguagesString(): string {
    return Experience.extractExperienceLangsString(this.experience!, 'it');
  }

  formatDuration(duration: string): string {
    if (!duration) {
      return '';
    }

    const parts = duration.split(' ');

    if (parts.includes('0d')) {
      const hoursAndMinutes = parts.slice(1).join(' ');
      return hoursAndMinutes === '' ? '0m' : hoursAndMinutes;
    }

    if (parts.includes('0h') && parts.includes('0m')) {
      return '0m';
    }

    if (parts.includes('0h')) {
      return parts.slice(parts.indexOf('0h') + 1).join(' ');
    }

    return duration;
  }
  replaceDashesWithPipe(text: string | undefined) {
    if (!text) return undefined;
    const parts = text?.split('-');
  }
  showMap = true;
  mapCoordinates = { latitude: 40.4168, longitude: -3.7038 };
  hasNextTranslation(index: number, totalTranslations: number): boolean {

    return index < totalTranslations - 1;
  }
  resetForm() {
    this.checkoutForm?.reset();
    this.isLanguageSelected = false;
    this.isLanguageAndDateSelected = false;
    this.isLanguageDateAndTimeSelected = false;
    this.isExtraDisabled=true;
    this.isDateSelected = false;
    this.selectedLanguage = null;
    this.selectedTime = null;
    this.selectedDate = null;
    this.availableTimes = [];

    if (this.peopleDropdown) {
      this.peopleDropdown.reset();
    }

    if (this.extraDropdown) {
      this.extraDropdown.reset();
    }
  }
  
  onSubmit(form: NgForm) {
    if (form.invalid) {
      console.warn('Form non valido');
      return;
    }

    // Recupero dei valori dai dropdown
    const peopleDropdownValues: number[] = this.labelCounts.slice(); // Usa labelCounts se è la fonte dei valori
    const extraDropdownValues: string[] = []; // Se hai un dropdown per extras, aggiorna questa variabile

    // Reset del formData nel servizio
    this.formDataService.resetFormData();

    // Creazione dell'oggetto formData
    const commonData = {
      experienceId: this.experienceId || '',
      numberOfPeople: this.numberOfPeople,
      people: peopleDropdownValues,
      totalPrice: this.combinedTotalPrice,
      experience_price_labels: (this.experience?.prices ?? []).map((price, index) => ({
        count: peopleDropdownValues[index] || 0,
        id: index,
        title_translations: {} as any, // Mantenuto per compatibilità, ma usare priceTitle o priceDescription
        priceTitle: price.priceTitle || price.priceDescription || 'Extra',
        priceDescription: price.priceDescription || '',
        price_cents: price.price || 0,
        price_currency: price.priceCurrency || 'EUR',
        position: index,
        experience_id: this.experience?.id || '',
        created_at: '',
        updated_at: '',
        quantity: 0
      })) || [],
      price01_label_with_count: {
        label: this.experience?.prices?.[0]?.priceDescription || 'N/A',
        count: this.numberOfPeople
      }
    };

    let formData: any;

    if (this.isReservation) {
      // Se è una prenotazione (Prenota)
      formData = {
        ...commonData,
        language: this.formData.language,
        date: this.formData.date,
        time: this.formData.time,
        extras: extraDropdownValues.join(', '),
        isReservation: true
      };
    } else {
      // Se è un regalo (Regala)
      formData = {
        ...commonData,
        language: 'Italiano', // Lingua fissa per il regalo
        isReservation: false
      };
    }

    // Save state before navigating to checkout
    this.saveExperienceState();

    // Imposta i dati del form nel servizio
    this.formDataService.setFormData(formData);

    // Naviga alla pagina di checkout
    this.router.navigate(['/checkout']);
  }
  
  

  formatCurrencyCents(number: number | undefined): string {
    if (!!!number) number = 0;
    var numEur = number / 100;
    return this.cp.transform(numEur, 'EUR', 'symbol', '1.0-0') || "";
  }

  /**
   * Get the first LABEL price (position 0) which contains the main price description
   */
  getFirstLabelPrice() {
    if (!this.experience?.prices) return null;
    return this.experience.prices.find(p => p.priceType === 'LABEL' && p.position === 0);
  }

  /**
   * Get all LABEL prices except the first one (position > 0)
   */
  getExtraLabelPrices() {
    if (!this.experience?.prices) return [];
    return this.experience.prices
      .filter(p => p.priceType === 'LABEL' && p.position > 0)
      .sort((a, b) => (a.position || 0) - (b.position || 0));
  }

  /**
   * Get all EXTRA prices
   */
  getExtraPrices() {
    if (!this.experience?.prices) return [];
    return this.experience.prices
      .filter(p => p.priceType === 'EXTRA')
      .sort((a, b) => (a.position || 0) - (b.position || 0));
  }
  maxLenghtText(text: string, maxLength: number): string {

    if (text && text.length <= maxLength) {
      return text;
    } else if (text) {
      return text.substring(0, maxLength - 3) + '...';
    } else {
      return '';
    }
  }

  getImageUrl(mediaUrl: string | undefined | null, large: boolean = true): string {
    // Per la pagina dettaglio usiamo sempre immagini grandi (large = true)
    return getImageUrl(mediaUrl, large);
  }

  getWineryLogoUrl(): string {
    // Extract logo from experience.winery.logo (publicId) and convert to Cloudinary URL
    const logoPublicId = this.experience?.winery?.logo;
    if (!logoPublicId) {
      return '';
    }
    
    // The publicId from backend can be in format "production/store/ymt8innzjjkss9cmfnxk"
    // or just "ymt8innzjjkss9cmfnxk"
    // getImageUrl expects just the filename part (after the last '/')
    // It will automatically prepend "v1/production/store/"
    let filename = logoPublicId;
    if (logoPublicId.includes('/')) {
      const publicIdParts = logoPublicId.split('/');
      filename = publicIdParts[publicIdParts.length - 1];
    }
    
    // Use false for large parameter to get a smaller image suitable for logo (80x80px)
    return getImageUrl(filename, false);
  }

  /**
   * Calculate day statuses based on availability (similar to widget)
   * Statuses: 'full-available' (green), 'partial-available' (yellow), 'sold-out' (red), 'no-booked' (red)
   */
  private calculateDayStatuses(): void {
    this.dayStatuses = {};
    
    if (!this.availabilities || this.availabilities.length === 0) {
      return;
    }

    this.availabilities.forEach((dayData) => {
      if (!dayData.availabilities || dayData.availabilities.length === 0) {
        this.dayStatuses[dayData.day] = 'no-booked';
        return;
      }

      // Calculate totals for the day
      const totalMaxParties = dayData.availabilities.reduce(
        (sum, slot) => sum + (slot.max_parties || 0),
        0
      );
      const totalOccupied = dayData.availabilities.reduce(
        (sum, slot) => sum + (slot.occupied_count || 0),
        0
      );
      const totalAvailable = totalMaxParties - totalOccupied;

      // Determine status
      let status: string;
      if (totalMaxParties === 0) {
        status = 'no-booked'; // No bookings available
      } else if (totalAvailable === 0) {
        status = 'sold-out'; // Sold out
      } else if (totalOccupied > 0 && totalAvailable > 0) {
        status = 'partial-available'; // Partially available (yellow)
      } else if (totalMaxParties > 0 && totalOccupied === 0) {
        status = 'full-available'; // Fully available (green)
      } else {
        status = 'no-booked'; // Default to no-booked
      }

      this.dayStatuses[dayData.day] = status;
    });
  }

  /**
   * Get CSS class for a date based on its availability status
   * Used in dateTemplate for PrimeNG calendar
   */
  getDateClass(date: any): string {
    if (!date || !date.day) {
      return '';
    }

    // Create a Date object from the calendar date
    const calendarDate = new Date(date.year, date.month, date.day);
    const dateString = this.formatDate(calendarDate);
    const status = this.dayStatuses[dateString];
    
    if (!status) {
      return '';
    }

    return `day-status-${status}`;
  }

  /**
   * Check if a date is selected (for highlighting)
   * Used in dateTemplate for PrimeNG calendar
   */
  checkIfDateSelected(date: any): boolean {
    if (!date || !date.day || !this.formData.date) {
      return false;
    }
    
    // Create a Date object from the calendar date
    const calendarDate = new Date(date.year, date.month, date.day);
    const dateString = this.formatDate(calendarDate);
    return dateString === this.formData.date;
  }

  private saveExperienceState(): void {
    if (!this.experienceId) return;
    
    // Get experience name from experience object or from route
    let experienceName = '';
    if (this.experience && this.experience.details?.title) {
      experienceName = this.experience.details.title;
    } else {
      // Try to get from route params as fallback
      const param = this.route.snapshot.paramMap.get('experience_name__experience_id');
      if (param) {
        const parts = param.split('__');
        if (parts.length > 0) {
          // Decode kebab case back to title (approximate)
          experienceName = parts[0].replace(/-/g, ' ');
        }
      }
    }
    
    const state = {
      selectedLanguage: this.selectedLanguage,
      selectedDate: this.selectedDate,
      selectedTime: this.selectedTime,
      labelCounts: [...this.labelCounts],
      numberOfPeople: this.numberOfPeople,
      peopleTotalPrice: this.peopleTotalPrice,
      extraTotalPrice: this.extraTotalPrice,
      combinedTotalPrice: this.combinedTotalPrice,
      formData: {
        language: this.formData.language,
        date: this.formData.date,
        time: this.formData.time,
        people: [...this.formData.people],
        extras: this.formData.extras
      },
      isLanguageSelected: this.isLanguageSelected,
      isLanguageAndDateSelected: this.isLanguageAndDateSelected,
      isLanguageDateAndTimeSelected: this.isLanguageDateAndTimeSelected,
      isDateSelected: this.isDateSelected,
      isReservation: this.isReservation,
      selectedTab: this.selectedTab,
      experienceId: this.experienceId,
      experienceName: experienceName
    };
    
    this.experienceStateService.saveState(state);
  }

  private restoreExperienceState(): void {
    const savedState = this.experienceStateService.getState();
    if (!savedState || savedState.experienceId !== this.experienceId) {
      return;
    }

    // Restore UI state first
    this.isReservation = savedState.isReservation !== undefined ? savedState.isReservation : true;
    this.selectedTab = savedState.selectedTab || 'Prenota';
    
    // Restore selected values
    this.selectedLanguage = savedState.selectedLanguage;
    this.selectedDate = savedState.selectedDate;
    this.selectedTime = savedState.selectedTime;
    this.labelCounts = savedState.labelCounts || [];
    this.numberOfPeople = savedState.numberOfPeople || 0;
    this.peopleTotalPrice = savedState.peopleTotalPrice || 0;
    this.extraTotalPrice = savedState.extraTotalPrice || 0;
    this.combinedTotalPrice = savedState.combinedTotalPrice || 0;
    
    // Restore form data
    this.formData.language = savedState.formData?.language || '';
    this.formData.date = savedState.formData?.date || '';
    this.formData.time = savedState.formData?.time || '';
    this.formData.people = savedState.formData?.people || [];
    this.formData.extras = savedState.formData?.extras || '';
    
    // Restore UI flags
    this.isLanguageSelected = savedState.isLanguageSelected || false;
    this.isLanguageAndDateSelected = savedState.isLanguageAndDateSelected || false;
    this.isLanguageDateAndTimeSelected = savedState.isLanguageDateAndTimeSelected || false;
    this.isDateSelected = savedState.isDateSelected || false;
    
    // Use setTimeout to ensure view is ready before restoring dropdowns
    setTimeout(() => {
      // If language was selected, reload availabilities
      if (this.isLanguageSelected && this.selectedLanguage && this.selectedLanguage.code) {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth() + 1;
        this.loadAvailabilities(year, month, this.selectedLanguage.code);
        // Wait a bit for availabilities to load, then restore date and time
        setTimeout(() => {
          this.restoreDateAndTime(savedState);
        }, 500);
      } else {
        this.restoreDateAndTime(savedState);
      }
    }, 100);
    
    // Clear the saved state after restoring
    this.experienceStateService.clearState();
  }

  private restoreDateAndTime(savedState: any): void {
    // If date was selected, restore available times
    if (this.isDateSelected && this.formData.date) {
      const availabilitiesForDay = this.getAvailabilitiesForDay(this.formData.date);
      if (availabilitiesForDay && availabilitiesForDay.availabilities) {
        this.availableTimes = availabilitiesForDay.availabilities.map(a => ({ 
          label: a.time, 
          value: a.time,
          minParties: a.min_parties,
          maxParties: a.max_parties,
          occupiedCount: a.occupied_count 
        }));
        
        // Restore selected time if it was selected
        if (this.selectedTime && this.formData.time) {
          const restoredTime = this.availableTimes.find(t => t.value === this.formData.time || t.label === this.formData.time);
          if (restoredTime) {
            this.selectedTime = restoredTime;
            this.onTimeSelect({ value: restoredTime });
          }
        }
      }
    }
    
    // If time was selected, restore time people info
    if (this.selectedTime && this.selectedTime.minParties !== undefined) {
      this.timePeopleInfo = {
        minParties: this.selectedTime.minParties || 0,
        maxParties: this.selectedTime.maxParties || 0,
        occupiedCount: this.selectedTime.occupiedCount || 0
      };
    }
    
    // Restore people dropdown state - trigger change events
    if (this.labelCounts.length > 0) {
      // The people dropdown should react to labelCounts changes
      // We might need to manually trigger the change if the component doesn't watch labelCounts
      setTimeout(() => {
        if (this.peopleDropdown) {
          // Try to restore the people dropdown state
          // This depends on how the people dropdown component works
        }
      }, 200);
    }
  }

  goBack(): void {
    // If there's saved experiences state, navigate directly to experiences list
    // Otherwise, use browser history to go back
    if (this.experiencesStateService.hasState()) {
      this.router.navigate(['/experiences']);
    } else {
      this.location.back();
    }
  }

  private showAvailabilityError(message: string) {
    this.isAvailabilityErrorVisible = true;
    this.availabilityErrorMessage = message;
  }

  hideAvailabilityError() {
    this.isAvailabilityErrorVisible = false;
    this.availabilityErrorMessage = '';
  }

}